import type { SuggestedAddon } from "./types";

// Static snapshot of the concise descriptions from the published pdp_addon
// metaobjects. The modal content is rendered by Liquid using the Shopify handle.
const ADDON_DESCRIPTIONS: Record<string, string> = {
  "bodenanalyse-kit":
    "Wir analysieren deinen Boden auf Nährstoffdefizite und passen deine Düngerformulierung darauf an.",
  "nachsaat-allwetter-fullsaat":
    "Schließt kahle Stellen und schafft eine dichte Rasennarbe, speziell bei Hitze und Kälte.",
  "celaflor-rasen-unkrautfrei-weedex":
    "Bekämpft mehr als 40 Unkrautarten und schont gleichzeitig deinen Rasen.",
  "eisendunger-moosfrei":
    "Bekämpft vermooste Flächen und gewinnt einen dichten Rasen zurück.",
  "saatgut-rasenpflaster":
    "Erste Hilfe für deinen Rasen: Beseitigt Rasenlücken schnell dank praktischer Kombi-Lösung.",
  "halm-wetting-agent":
    "Vermeidet & kuriert Trockenstellen. Spart Wasser während der trockenen Jahreszeit.",
  kraftsaat:
    "Lässt dichten, üppigen Rasen wachsen und schließt großflächige kahle Stellen.",
  "bodenverbesserer-bodenkraft":
    "Fördert die Bodengesundheit und erhöht die Widerstandsfähigkeit deines Rasens.",
  "rasenfarbe-1":
    "Überdeckt gelbe oder ausgeblichene Stellen im Rasen in Sekundenschnelle.",
  "fullsaat-nachsaat":
    "Schließt kahle Stellen und schafft eine dichte Rasennarbe innerhalb kurzer Zeit.",
};

export const getAddonDescription = (addon: SuggestedAddon) =>
  ADDON_DESCRIPTIONS[addon.slug ?? ""] ??
  "Ergänzt deine Rasenpflege passend zu den Bedürfnissen deines Rasens.";

export const getAddonModalId = (addon: SuggestedAddon) =>
  addon.slug ? `personalized-addon-modal-${addon.slug}` : null;
